'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(t, e, r) {
    return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : t[e] = r, t;
}
function _object_spread(t) {
    for(var e = 1; e < arguments.length; e++){
        var r = null != arguments[e] ? arguments[e] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(t) {
            return Object.getOwnPropertyDescriptor(r, t).enumerable;
        }))), o.forEach(function(e) {
            _define_property(t, e, r[e]);
        });
    }
    return t;
}
function _object_without_properties(t, e) {
    if (null == t) return {};
    var r, o, n = _object_without_properties_loose(t, e);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(t);
        for(o = 0; o < i.length; o++)r = i[o], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(t, r) && (n[r] = t[r]);
    }
    return n;
}
function _object_without_properties_loose(t, e) {
    if (null == t) return {};
    var r, o, n = {}, i = Object.keys(t);
    for(o = 0; o < i.length; o++)r = i[o], e.indexOf(r) >= 0 || (n[r] = t[r]);
    return n;
}
const TextInputWithButtonInset = renderWithRef('TextInputWithButtonInset', null, (r, o)=>{
    let { buttonPosition: n = 'right', children: i } = r, u = _object_without_properties(r, [
        "buttonPosition",
        "children"
    ]), p = new Set([
        'swan-vanilla-ignore',
        'swan-input-with-button-inset'
    ]);
    return 'left' === n && p.add("swan-input-with-button-left"), jsx(RenderComp, {
        root: "div",
        classNames: p,
        forwardedRef: o,
        props: _object_spread({
            role: 'group'
        }, u),
        children: i
    });
});

export { TextInputWithButtonInset };
